
import moment from 'moment';
import authHelper from './helpers/authHelper.js';
import { axiosErrorHandler, axiosResponseHandler, callTheUpServerGet, callTheUpServerPost } from './helpers/axiosHelper.js';
import { hydrateUserBasicData } from './helpers/basicHelper.js';
import { addDNoneClass, byId } from './helpers/utility.js';


authHelper.validate().then(async () => {

    await hydrateUserBasicData();


    // elements byId
    const cid_span1 = byId('cid_span1');
    const cid_span2 = byId('cid_span2');
    const cname_span1 = byId('cname_span1');
    const cname_span2 = byId('cname_span2');
    const UP_MOB_NUMBER_input = byId('UP_MOB_NUMBER_input');
    //   let  UP_MOB_NUMBER_edit_btn = byId('UP_MOB_NUMBER_edit_btn')
    //   let  UP_MOB_NUMBER_submit_btn = byId('UP_MOB_NUMBER_submit_btn')
    const UP_EMAIL_input = byId('UP_EMAIL_input');
    //   let  UP_EMAIL_edit_btn = byId('UP_EMAIL_edit_btn')
    //   let   UP_EMAIL_submit_btn = byId('UP_EMAIL_submit_btn')
    const UP_ALT_NUM_input = byId('UP_ALT_NUM_input');
    //   let  UP_ALT_NUM_edit_btn = byId('UP_ALT_NUM_edit_btn')
    //   let   UP_ALT_NUM_submit_btn = byId('UP_ALT_NUM_submit_btn')
    const UP_DOC_TYPE = byId('UP_DOC_TYPE');
    const UP_DOC_ID = byId('UP_DOC_ID');
    const UP_AADHAR_NUM = byId('UP_AADHAR_NUM');
    const UP_DOB = byId('UP_DOB');
    const address_span = byId('address_span');




    const BANK_edit_btn = byId('BANK_edit_btn');
    //   let   BANK_submit_btn = byId('BANK_submit_btn')
    const BANK_NAME = byId('BANK_NAME');
    const BANK_AC_NUM = byId('BANK_AC_NUM');
    const BANK_IFSC = byId('BANK_IFSC');
    const UPI_ID = byId('UPI_ID');
    let NOMINEE_NAME = byId('NOMINEE_NAME');
    let NOMINEE_NUMBER = byId('NOMINEE_NUMBER');
    let NOMINEE_RELATION = byId('NOMINEE_RELATION');
    const NOMINEE_NAME_span = byId('NOMINEE_NAME_span');
    const NOMINEE_NUMBER_span = byId('NOMINEE_NUMBER_span');
    const NOMINEE_RELATION_span = byId('NOMINEE_RELATION_span');
    let nominee_submit_btn = byId('nominee_submit_btn');
    const nominee_display_div = byId('nominee_display_div');
    let nominee_add_div = byId('nominee_add_div');





    const profilePageFun = {
        fetchData: async () => {
            try {
                const response = await callTheUpServerGet(`/basic/getProfileData`);
                axiosResponseHandler(response);
                const res = response.data;

                if (res.status === 'success') {
                    console.log(res);

                    const { userId, altMobileNumber, email, fullName, mobileNumber, users_bank_details, users_extra_details, users_kyc_details, users_nominee_details } = res.profileData;

                    const { bankName, accountNumber, ifscCode, upiId } = users_bank_details;
                    const { kycDocumentName, kycDocumentId, aadhaarNumber } = users_kyc_details;
                    const nomineeName = users_nominee_details.name;
                    const nomineeMobileNumber = users_nominee_details.mobileNumber;
                    const relation = users_nominee_details.relation;

                    const birthDate = moment(users_extra_details.birthDate * 1000).format('DD/MM/YYYY');

                    // setting id from local
                    cid_span1.innerHTML = cid_span2.innerHTML = userId;


                    cname_span1.innerHTML = cname_span2.innerHTML = fullName;
                    UP_MOB_NUMBER_input.value = mobileNumber;
                    UP_EMAIL_input.value = email;
                    UP_ALT_NUM_input.value = altMobileNumber;
                    UP_DOC_TYPE.innerHTML = kycDocumentName;
                    UP_DOC_ID.innerHTML = kycDocumentId;
                    UP_AADHAR_NUM.innerHTML = aadhaarNumber;
                    UP_DOB.innerHTML = birthDate;
                    address_span.innerHTML = users_extra_details.address + ',' + users_extra_details.city;



                    BANK_NAME.value = bankName;
                    BANK_AC_NUM.value = accountNumber;
                    BANK_IFSC.value = ifscCode;
                    UPI_ID.value = upiId;

                    /* validation  */

                    if (accountNumber === '' && upiId === '') {
                        addDNoneClass(BANK_edit_btn, false);

                    }

                    if (nomineeName !== '') {
                        addDNoneClass(nominee_add_div, true);
                        addDNoneClass(nominee_display_div, false);

                        NOMINEE_NAME_span.innerHTML = nomineeName;
                        NOMINEE_NUMBER_span.innerHTML = nomineeMobileNumber;
                        NOMINEE_RELATION_span.innerHTML = relation;
                    }






                }
            } catch (error) {
                axiosErrorHandler(error);
                console.log(error);
            }
        },
        edit: {
            usersBankDetails: {
                init: (status) => {
                    const edit_btn = document.getElementById('BANK_edit_btn');
                    const submit_btn = document.getElementById('BANK_submit_btn');
                    const name_input = document.getElementById('BANK_NAME');
                    const ac_num_input = document.getElementById('BANK_AC_NUM');
                    const ifsc_input = document.getElementById('BANK_IFSC');
                    const upi_input = document.getElementById('UPI_ID');

                    // actions
                    if (status === true) {
                        name_input.removeAttribute('readonly');
                        ac_num_input.removeAttribute('readonly');
                        ifsc_input.removeAttribute('readonly');
                        upi_input.removeAttribute('readonly');
                        edit_btn.classList.add('d-none');
                        submit_btn.classList.remove('d-none');
                    }
                    if (status === false) {
                        name_input.setAttribute('readonly', '');
                        ac_num_input.setAttribute('readonly', '');
                        ifsc_input.setAttribute('readonly', '');
                        upi_input.setAttribute('readonly', '');
                        edit_btn.classList.remove('d-none');
                        submit_btn.classList.add('d-none');
                    }


                },
                submit: async () => {
                    try {

                        const edit_btn = document.getElementById('BANK_edit_btn');
                        // let   submit_btn = document.getElementById('BANK_submit_btn');
                        const name_input = document.getElementById('BANK_NAME');
                        const ac_num_input = document.getElementById('BANK_AC_NUM');
                        const ifsc_input = document.getElementById('BANK_IFSC');
                        const upi_input = document.getElementById('UPI_ID');

                        // actions
                        profilePageFun.edit.usersBankDetails.init(false);
                        edit_btn.textContent = 'Processing';
                        edit_btn.disabled = true;


                        /// api call
                        const data = {
                            accountNumber: ac_num_input.value,
                            bankName: name_input.value,
                            ifscCode: ifsc_input.value,
                            upiId: upi_input.value
                        };
                        const response = await callTheUpServerPost('/basic/updateUsersBankDetails', { data });
                        axiosResponseHandler(response);

                        edit_btn.disabled = false;

                        const res = response.data;

                        if (res.status === 'success') {
                            console.log(res);
                            addDNoneClass(BANK_edit_btn, true);
                        } else {
                            edit_btn.textContent = 'Retry';
                        }











                    } catch (error) {
                        axiosErrorHandler(error);
                    }
                }
            },
            usersNomineeDetails: {
                init: () => {
                    const nominee_submit_div = document.getElementById('nominee_submit_div');
                    nominee_add_div = document.getElementById('nominee_add_div');
                    nominee_submit_div.classList.remove('d-none');
                    nominee_add_div.classList.add('d-none');
                },
                submit: async () => {
                    try {
                        const nominee_submit_div = document.getElementById('nominee_submit_div');
                        nominee_submit_btn = document.getElementById('nominee_submit_btn');
                        NOMINEE_NAME = document.getElementById('NOMINEE_NAME');
                        NOMINEE_NUMBER = document.getElementById('NOMINEE_NUMBER');
                        NOMINEE_RELATION = document.getElementById('NOMINEE_RELATION');
                
                        ///actions
                        nominee_submit_btn.textContent = 'Processing';
                        nominee_submit_btn.disabled = true;
                
              


                        /// api call
                        const data = {
                            name: NOMINEE_NAME.value,
                            relation: NOMINEE_RELATION.value,
                            mobileNumber: NOMINEE_NUMBER.value
                        };
                        const response = await callTheUpServerPost('/basic/updateUsersNomineeDetails', { data });
                        axiosResponseHandler(response);

                        nominee_submit_btn.disabled = false;

                        const res = response.data;

                        if (res.status === 'success') {
                            profilePageFun.fetchData();
                            nominee_submit_btn.textContent = 'EDIT';
                            addDNoneClass(nominee_submit_div,true);
                        } else {
                    
                            nominee_submit_btn.textContent = 'Retry';
                        }











                    } catch (error) {
                        axiosErrorHandler(error);
                    }
                }
            }
        }
    };
    window.profilePageFun = profilePageFun;


    
    profilePageFun.fetchData();










 








});










